import { render, staticRenderFns } from "./ServicoDigitalDetalhe.vue?vue&type=template&id=7ab5311b&lang=true"
import script from "./ServicoDigitalDetalhe.vue?vue&type=script&lang=js"
export * from "./ServicoDigitalDetalhe.vue?vue&type=script&lang=js"
import style0 from "./ServicoDigitalDetalhe.vue?vue&type=style&index=0&id=7ab5311b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports